import { useId, type TextareaHTMLAttributes } from 'react'

import { cn } from '@/_lib/utils'

import { MFieldError } from './m-field-error'

import type { UseFormRegisterReturn } from 'react-hook-form'

const textareaBoomexBase =
	'peer w-full resize-none rounded-[10px] border border-solid border-medante-purple-dark bg-medante-background text-sm font-semibold text-medante-purple-dark ' +
	'placeholder:text-transparent outline-none transition-[color,border-color] ' +
	'pt-[23px] pb-[14px] pl-[25px] pr-6 max-md:pt-[18px] max-md:text-[13px] ' +
	'md:rounded-[14px] ' +
	'focus:border-medante-purple-dark focus:ring-0 focus-visible:ring-0 ' +
	'[&:-webkit-autofill]:[-webkit-text-fill-color:#4a337a] [&:-webkit-autofill]:shadow-[inset_0_0_0_1000px_#fdfbf7] [&:-webkit-autofill]:[transition:background-color_600000s_ease] ' +
	'disabled:opacity-50'

const textareaBoomexError = 'border-[#fe2b20] text-[#fe2b20]'

const floatLabelBase =
	'pointer-events-none absolute left-[25px] top-[19px] z-[1] max-w-[calc(100%-2rem)] origin-top-left font-normal transition-transform duration-200 ease-out max-md:top-[15px] max-md:text-[13px] ' +
	'peer-focus:-translate-y-[10px] peer-focus:scale-90 ' +
	'peer-[&:not(:placeholder-shown)]:-translate-y-[10px] peer-[&:not(:placeholder-shown)]:scale-90 ' +
	'peer-[&:-webkit-autofill]:-translate-y-[10px] peer-[&:-webkit-autofill]:scale-90'

type Props = {
	label: string
	required?: boolean
	error?: string
	registration: UseFormRegisterReturn
} & Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'size' | 'placeholder'>

export function MTextarea({
	label,
	required,
	error,
	registration,
	className,
	rows = 3,
	...textareaProps
}: Props) {
	const id = useId()
	const invalid = Boolean(error)

	return (
		<div>
			<div className='relative'>
				<textarea
					id={id}
					rows={rows}
					className={cn(textareaBoomexBase, invalid && textareaBoomexError, className)}
					placeholder=' '
					aria-invalid={invalid}
					{...registration}
					{...textareaProps}
				/>
				<label
					htmlFor={id}
					className={cn(
						floatLabelBase,
						'text-sm text-medante-purple-dark',
						invalid && 'text-[#fe2b20]'
					)}
				>
					{label}
					{required && <span className='text-[#fe2b20]'>*</span>}
				</label>
			</div>
			<MFieldError message={error} />
		</div>
	)
}
